/**
 * This file contains a React component which renders the dropdowns in the
 * header of the page.
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle, type StyleType} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {zindexDropdown} from "@khan/shared-styles";

type Props = {
    // Optional identifier for the dropdown.
    id?: string;
    // The child elements which go in the dropdown.
    children: React.ReactNode;
    // Extra Aphrodite styles to apply to the dropdown.
    dropdownStyles: StyleType;
    // Whether or not the dropdown should have a border and drop shadow.
    hasBorder: boolean;
    // Whether or not the dropdown is currently visible.
    visible: boolean;
    // The test Id
    testId?: string;
    // Whether or not to wrap the content in a div (instead of ul)
    hasDivWrapper: boolean;
};

// @ts-expect-error - TS2558 - Expected 2 type arguments, but got 1.
const StyledDiv = addStyle<"div">("div");
// @ts-expect-error - TS2558 - Expected 2 type arguments, but got 1.
const StyledUl = addStyle<"ul">("ul");

export default class HeaderDropdown extends React.Component<Props> {
    static defaultProps: {
        dropdownStyles: Array<any>;
        hasBorder: boolean;
        hasDivWrapper: boolean;
        visible: boolean;
    } = {
        visible: false,
        hasBorder: true,
        hasDivWrapper: false,

        dropdownStyles: [],
    };

    render(): React.ReactNode {
        const props = {
            style: [
                styles.dropdown,
                this.props.visible && styles.dropdownOpen,
                this.props.hasBorder && styles.dropdownBorder,
                this.props.dropdownStyles,
            ],
            id: this.props.id,
            "data-testid": this.props.testId,
        } as const;

        return this.props.hasDivWrapper ? (
            // @ts-expect-error - TS2322 - Type '{ children: ReactNode; style: readonly [CSSProperties, false | CSSProperties, false | CSSProperties, StyleType]; id: string | undefined; "data-testid": string | undefined; }' is not assignable to type 'PropsWithoutRef<{ className?: string | undefined; style?: StyleType; children?: ReactNode; } & Omit<ComponentProps<T>, "style">>'.
            <StyledDiv {...props}>{this.props.children}</StyledDiv>
        ) : (
            // @ts-expect-error - TS2322 - Type '{ children: ReactNode; style: readonly [CSSProperties, false | CSSProperties, false | CSSProperties, StyleType]; id: string | undefined; "data-testid": string | undefined; }' is not assignable to type 'PropsWithoutRef<{ className?: string | undefined; style?: StyleType; children?: ReactNode; } & Omit<ComponentProps<T>, "style">>'.
            <StyledUl {...props}>{this.props.children}</StyledUl>
        );
    }
}

const styles = StyleSheet.create({
    dropdown: {
        display: "none",
        position: "absolute",
        zIndex: zindexDropdown,
    },

    dropdownOpen: {
        display: "block",
    },

    dropdownBorder: {
        border: "1px solid " + color.offBlack16,
        boxShadow: "0 5px 8px rgba(0, 0, 0, 0.5)",
    },
});
